import React from "react";

const RadiosScale = ({ label, reqd, data, value, click, error }) => {
  const labels = data.map((item, index) => {
    return (
      <label
        key={index}
        className={!item.label ? "hidden" : ""}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <input
          type="radio"
          name={item.name}
          value={item.val}
          defaultChecked={item.val === value}
          onClick={(e) => click(item.name, e.target.value)}
        />
        <span style={{ paddingLeft: "0", paddingTop: "2.5px" }}>
          {item.label}
        </span>
      </label>
    );
  });

  return (
    <div className={error ? "has-error" : ""}>
      <label className="control-label">
        {label} <span className="reqd">{reqd ? "*" : " "}</span>
      </label>
      <div className="inline">{labels}</div>
    </div>
  );
};

export default RadiosScale;
